// extracted by mini-css-extract-plugin
export var root = "F_wm";
export var wrapper = "F_wn";
export var image = "F_wp d_w d_y d_W";
export var imageWithHeight = "F_wq";
export var crop = "F_wr";
export var round = "F_ws";
export var fixedHeight = "F_wt";